
import { Component, Prop, Vue } from 'vue-property-decorator'
import type { FaqCategory, FaqItem } from '../types'

@Component
export default class CategorySidebar extends Vue {
  @Prop({ type: Array, required: true }) readonly categories!: FaqCategory[]
  @Prop({ type: String, default: '' }) readonly activeCategoryId!: string
  @Prop({ type: String, default: '' }) readonly activeItemId!: string

  handleCategoryClick(category: FaqCategory): void {
    this.$emit('category-click', category.id)
  }

  handleQuestionClick(item: FaqItem): void {
    this.$emit('question-click', item.id)
  }
}
